(() => {
  let cleanup;
  function init() {
    if (cleanup) cleanup();
    const dialog = document.querySelector('[data-holiday-popup]');
    if (!dialog) return;
    const config = JSON.parse(dialog.querySelector('[data-notice-config]').textContent);
    if (!config.enabled && !config.editor) return;
    const key = 'std-holiday-notice:' + config.campaign;
    let shown = false, started = Date.now(), disposed = false;
    try {
      started = Number(sessionStorage.getItem(key + ':started')) || started;
      if (!config.editor) sessionStorage.setItem(key + ':started', String(started));
      shown = config.frequency === 'day' ? Date.now() - (Number(localStorage.getItem(key + ':shownAt')) || 0) < 86400000 : sessionStorage.getItem(key + ':shown') === 'true';
    } catch (_) {}
    function open() {
      if (disposed || dialog.open) return;
      dialog.showModal(); shown = true;
      if (!config.editor) { try { sessionStorage.setItem(key + ':shown','true'); localStorage.setItem(key + ':shownAt',String(Date.now())); } catch (_) {} }
    }
    function close() { if (dialog.open) dialog.close(); }
    function tick() {
      if (config.editor || shown || Date.now() - started < config.delay * 1000 || document.visibilityState !== 'visible') return;
      if (document.body.classList.contains('show-cart-summary') || document.body.classList.contains('show-mobile-nav') || document.querySelector('[data-event-panel]:not([hidden]), [data-promo-panel]:not([hidden]), [data-pair-panel]:not([hidden]), dialog[open]')) return;
      open();
    }
    const buttons = dialog.querySelectorAll('[data-notice-close]');
    buttons.forEach(button => button.addEventListener('click', close));
    const interval = setInterval(tick, 500);
    document.addEventListener('visibilitychange', tick);
    if (config.editor && config.preview) open(); else tick();
    cleanup = () => { disposed = true; clearInterval(interval); close(); buttons.forEach(button => button.removeEventListener('click',close)); document.removeEventListener('visibilitychange',tick); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',init);
})();
